import styled, { keyframes } from 'styled-components';

const Spin = keyframes`
    from {
      transform: rotate(0);
    }
  to {
    transform: rotate(359deg);
  }
`;

export const Spinner = styled.div`
  display: inline-block;
  color: ${({ theme }) => theme.brand.primary.base};
  animation: ${Spin} infinite 0.5s linear;
`;
